import React, { useState, useEffect, useContext } from "react"
import { useScrollDirection } from '../../../utility/hooks/useScrollDirection'
import { useTranslation } from "react-i18next"
// import { router } from "../../../utility/router"
import { PageContext } from "../Page"
import DesktopHeader from './DesktopHeader'
import MobileHeader from './MobileHeader'

const Header = ({ type, theme, isTransparent }) => {
  const [isTopOfThePage, setIsTopOfThePage] = useState(true)
  const scrollDirection = useScrollDirection()
  const topPosition = scrollDirection === 'down' ? '-top-header opacity-0' : 'top-0 opacity-100'
  const shadow = isTopOfThePage ? '' : 'shadow-lg'
  const [t] = useTranslation("layout")
  const context = useContext(PageContext)
  let logoUrl
  if (type === 'landing (absolute urls)') {
    logoUrl = t('absoluteUrls.logo')
  } else if (type === 'landing (fabrick.com)') {
    logoUrl = '/'
  } else {
    logoUrl = ('/' + context.folder + '/')
  }

  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset === 0) {
        setIsTopOfThePage(true)
      } else {
        setIsTopOfThePage(false)
      }
    }

    return () => (window.onscroll = null)
  })

  // console.log(topPosition)
  // console.log(isTopOfThePage)

  return <>
    <DesktopHeader
      type={type}
      theme={theme}
      isTransparent={isTransparent}
      topPosition={topPosition}
      isTopOfThePage={isTopOfThePage}
      shadow={shadow}
      logoUrl={logoUrl}
    />
    <MobileHeader
      type={type}
      theme={theme}
      isTransparent={isTransparent}
      topPosition={topPosition}
      isTopOfThePage={isTopOfThePage}
      shadow={shadow}
      logoUrl={logoUrl}
    />
  </>
}

export default Header